module.exports = __webpack_public_path__ + "static/media/logo.dadbb2f7.svg";